module.exports = __webpack_public_path__ + "img/1504044454.b579ca02.jpg";